import { AppEnv } from '../../shared/appEnv';
import { FeatureToggleName, IFeatureToggle } from '../featureToggles.types';
import { extendDefaultFeatureToggles } from './default';

/** Stage overrides. Anything not listed inherits the production value. */
const stageOverrides: IFeatureToggle[] = [
    { name: FeatureToggleName.Config_FeatureFlagCheckPage, isEnabled: true },
];

export const featureTogglesStage = extendDefaultFeatureToggles(
    AppEnv.Stage,
    stageOverrides,
);
